<template>
  <basic-container>
    <div class="avue-crud abc qcTaskProcess p-r">
      <section :class="[isShowPreview ? 'topPartBox' : '']">
        <section
          class="d-f align-c f-s-13 c-666"
          v-show="!errorFilterMode.isOpen"
        >
          <span v-if="showDown" class="downBtn" @click="backDown">DOWN</span>
          <div class="d-f align-c m-r-10">
            <span class="w-85">最后审核人：</span>
            <select-name-list
              v-model="search.name"
              :orderId="orderId"
              :qcTaskId="taskType == 2 ? qcTaskId : search.qcTaskId"
              :qcStatus="search.qcResult"
              :flag="getNameListFlag"
            ></select-name-list>
          </div>
          <div class="d-f align-c m-r-10">
            <span class="w-70">风险程度：</span>
            <select-risk-level-list
              v-model="search.levelList"
            ></select-risk-level-list>
          </div>
          <div class="d-f align-c m-r-10">
            <span class="w-70">质控结果：</span>
            <select-qc-result-list
              v-model="search.qcResult"
            ></select-qc-result-list>
          </div>
          <div
            class="d-f align-c m-r-10 qcTaskId"
            v-if="parseInt(taskType) === 1 && qcTaskIdFlag"
          >
            <span class="w-85">质控任务ID：</span>
            <select-qc-task-id-list
              v-model="search.qcTaskId"
              :options="qcTaskIdDic"
            ></select-qc-task-id-list>
          </div>
          <div class="d-f align-c m-r-10">
            <span class="w-60">原文：</span>
            <el-input
              clearable
              v-model="search.srcText"
              placeholder="请输入原文"
            />
          </div>
          <div class="d-f align-c m-r-10">
            <span class="w-60">译文：</span>
            <el-input
              clearable
              v-model="search.tranText"
              placeholder="请输入译文"
            />
          </div>
          <el-button
            type="primary"
            @click="searchChange()"
            class="el-icon-search"
          >
            搜索
          </el-button>
          <el-button type="default" @click="resetChange" class="el-icon-delete">
            清空
          </el-button>
        </section>
        <section class="d-f justify-b m-tb-10">
          <div class="d-f align-c">
            <el-button
              class="m-r-10"
              plain
              type="primary"
              @click="batchNoMisstake"
            >
              批量已阅无误
            </el-button>
            <el-button
              class="find-replace-button"
              type="primary"
              @click="findReplaceVisible = true"
            >
              批量替换译文
            </el-button>
            <el-button
              type="primary"
              v-if="showCaseBtn"
              @click="updateLowError('3002')"
            >
              全部首字母大写
            </el-button>
            <el-button
              type="primary"
              v-if="showHalfAngleBtn"
              @click="updateLowError('1002')"
            >
              全部全角转半角
            </el-button>
            <el-button
              type="primary"
              v-if="showFullAngleBtn"
              @click="updateLowError('1001')"
            >
              全部半角转全角
            </el-button>
            <el-button
              v-if="oneStepData.showOneStep && showItemFlag"
              type="success"
              class="el-icon-circle-check"
              plain
              @click="openOneStepOkDialog"
              :loading="isLoad"
            >
              一键已阅无误
            </el-button>
            <el-tooltip
              v-if="oneStepData.showOneStep && showItemFlag"
              effect="dark"
              content="至少举报标记三个有问题的句子"
              placement="bottom"
            >
              <el-button
                v-if="oneStepData.showOneStep && showItemFlag && peStatus != 4"
                type="danger"
                class="el-icon-circle-close"
                plain
                @click="showOneStepReturnManual"
                :loading="isLoad"
              >
                一键打回任务池
              </el-button>
            </el-tooltip>
            <el-button v-if="showReturnBtn" type="primary" @click="backToQc">
              打回任务
            </el-button>
          </div>
          <div class="d-f align-c">
            <el-button
              class="m-r-10"
              type="primary"
              @click="openTermListDialog"
              plain
            >
              查看加持术语表
            </el-button>
            <el-button
              class="m-r-10"
              type="primary"
              @click="openTermDialog"
              plain
            >
              新增术语
            </el-button>
            <el-badge
              class="m-r-10"
              v-if="parseInt(taskType) === 1"
              :is-dot="termAuditDotVisible"
            >
              <el-button type="primary" @click="openTermAuditDialog" plain>
                术语审核
              </el-button>
            </el-badge>
          </div>
        </section>
        <section class="d-f justify-b m-b-5">
          <div class="d-f">
            <el-tag
              size="large"
              class="m-r-5"
              v-if="flowLevel == 3 || flowLevel == 4 || flowLevel == 5"
            >
              <span v-if="flowLevel == 3 || flowLevel == 5">
                未完成PE翻译任务：{{ noFinish.peNum || 0 }}句
              </span>
              <span v-if="flowLevel == 4 || flowLevel == 5" class="m-l-5">
                未完成PE审核任务：{{ noFinish.peAuditNum || 0 }}句
              </span>
            </el-tag>
            <el-tag size="large" v-if="oneStepData.showOneStep" type="warning">
              <span>
                审核一次通过率：{{
                  oneStepData.peAuditDetail.passPercent
                }}%，共{{ oneStepData.peAuditDetail.sentenceNum }}句
              </span>
            </el-tag>
            <el-button type="primary" @click="mergeText">
              异常原文合并
            </el-button>
          </div>
          <div class="d-f">
            <el-tag size="large" type="warning">
              <span>若有项目存在重大风险，请及时告知PM</span>
            </el-tag>
          </div>
        </section>
        <el-table
          class="f-s-14 tableClass"
          style="width: 100%"
          border
          ref="main"
          :data="flowTaskData"
          :row-class-name="getGrey"
          v-loading.fullscreen="tableLoading"
          @cell-click="clickCell"
          row-key="fileId"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40"></el-table-column>
          <el-table-column
            prop="name"
            label="最后审核人"
            min-width="100"
            align="center"
            :resizable="false"
          >
            <template slot-scope="scope">
              <span style="word-break: break-word">
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="srcText" min-width="220" align="center">
            <template v-slot:header>
              原文
              <span class="c-primary f-w-400">(双击原文可定位查看原稿)</span>
            </template>
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.lock"
                type="warning"
                size="mini"
                class="p-a top-5 right-5"
              >
                锁定语料
              </el-tag>
              <div
                class="p-t-20"
                style="word-break: break-word"
                @dblclick="toPreview(scope.row, 1)"
                @click.right.prevent="
                  handleRightClick('src', scope.row, $event)
                "
              >
                <rich-text
                  :pId="scope.row.id"
                  :jsonText="scope.row.srcText"
                  :highlight="rebuildHighlight(scope.row?.termPosVosSrc)"
                  readonly
                />
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="mtText"
            label="机翻译文"
            min-width="210"
            align="center"
          >
            <template slot-scope="scope">
              <div
                class="c-p"
                style="word-break: break-word"
                @click.right.prevent="
                  handleRightClick('target', scope.row, $event)
                "
              >
                <rich-text
                  :pId="scope.row.id"
                  :jsonText="scope.row.mtText"
                  readonly
                />
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="peTextVo"
            label="译文"
            min-width="250"
            align="center"
          >
            <template slot-scope="scope">
              <translated-text-column
                :ref="`richtext-column-${scope.row.id}`"
                :row="scope.row"
                type="detail"
                :index="scope.$index"
                :focusIndex="focusIndex"
                :isQcOperate="permissions?.qc_operate"
                :qcTaskId="qcTaskId"
                :userInfo="userInfo"
                :errTagList="errTagList"
                @reset-peText="resetPeText"
                @open-quick-actions="handleRightClick"
                @imitate-input="imitateInput"
                @blur-text="blurText"
                @focus-text="focusText"
                @submit-qc-update-text="submitQcUpdateText"
              ></translated-text-column>
            </template>
          </el-table-column>
          <el-table-column
            prop="termList"
            label="术语"
            min-width="140"
            align="center"
          >
            <template slot-scope="scope">
              <term-list-column :row="scope.row"></term-list-column>
            </template>
          </el-table-column>
          <el-table-column
            prop="taskStatus"
            label="质控结果"
            width="100"
            :resizable="false"
            align="center"
          >
            <template slot-scope="scope">
              <qc-status-column :row="scope.row"></qc-status-column>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="120"
            :resizable="false"
            v-if="permissions.qc_operate"
          >
            <template slot-scope="scope">
              <action-btns-column
                :row="scope.row"
                :peStatus="peStatus"
                :qcTaskId="qcTaskId"
                :orderTag="orderTag"
                :userInfo="userInfo"
                :hasContextView="true"
                @load-page="loadPage"
                @open-return-task-pool-dialog="
                  openReturnTaskPoolDialog(scope.row)
                "
                @read-no-mistake="readNoMistake(scope.row)"
                @view-context="viewContext(scope.row)"
                @open-cancel-merge-dialog="openCancelMergeDialog(scope.row)"
              ></action-btns-column>
            </template>
          </el-table-column>
        </el-table>
        <div class="d-f align-c justify-end t-r">
          <span class="f-s-14 m-r-10 c-primary">
            进度：{{ wordProgress.finishWordCount }}/{{
              wordProgress.wordCount
            }}
          </span>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.current"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
          ></el-pagination>
        </div>
      </section>

      <!-- 原文预览 -->
      <doc-preview
        :visible.sync="isShowPreview"
        :row="currentRow"
        :peKey="peKey"
      ></doc-preview>

      <!-- 查看上下文 -->
      <!-- pe-context-drawer-sign: 用于判断弹窗是否展开，删除前需要先全局搜索下 -->
      <el-drawer
        title="查看上下文"
        :visible.sync="contextDrawer"
        v-if="contextDrawer"
        direction="ltr"
        size="85%"
        class="drawer-detail pe-context-drawer-sign"
      >
        <avue-crud
          :option="contextOption"
          :data="contextData"
          :row-class-name="rowStyle"
          @cell-click="clickCell"
        >
          <el-table-column
            prop="name"
            label="最后审核人"
            width="100"
            align="center"
            :resizable="false"
          >
            <template slot-scope="scope">
              <span
                style="word-break: break-word"
                @click="openQcMessageDialog(scope.row)"
              >
                {{ scope.row.name }}
              </span>
            </template>
          </el-table-column>
          <template slot-scope="scope" slot="srcText">
            <div
              @click="toPreview(scope.row, 0)"
              style="word-break: break-word"
              :data-sentenceNo="scope.row.sentenceNo"
              :data-current-sentenceNo="currentRow.sentenceNo"
            >
              <rich-text
                :pId="scope.row.id"
                :jsonText="scope.row.srcText"
                readonly
              />
            </div>
          </template>
          <!-- <template slot-scope="scope" slot="mtText">
            <span style="word-break: break-word">
              <rich-text
                :pId="scope.row.id"
                :jsonText="scope.row.mtText"
                readonly
              />
            </span>
          </template> -->
          <template slot-scope="scope" slot="peText">
            <translated-text-column
              type="context"
              :row="scope.row"
              :currentRow="currentRow"
              :index="scope.row.$index"
              :focusIndex="focusIndex"
              :isQcOperate="permissions?.qc_operate"
              :qcTaskId="qcTaskId"
              :userInfo="userInfo"
              :errTagList="errTagList"
              @open-quick-actions="handleRightClick"
              @imitate-input="imitateInput"
              @blur-text="blurText"
              @focus-text="focusText"
              @reset-peText="resetPeText"
              @submit-qc-update-text="submitQcUpdateText"
            ></translated-text-column>
          </template>
          <template slot-scope="scope" slot="termInfoList">
            <!-- 术语 -->
            <term-list-column
              :row="scope.row"
              :currentRow="currentRow"
            ></term-list-column>
          </template>
          <!-- 质控结果 -->
          <template slot-scope="scope" slot="qcStatus">
            <qc-status-column
              :row="scope.row"
              :currentRow="currentRow"
            ></qc-status-column>
          </template>
          <!-- 操作 -->
          <template slot-scope="scope" slot="control">
            <action-btns-column
              :row="scope.row"
              :peStatus="peStatus"
              :qcTaskId="qcTaskId"
              :orderTag="orderTag"
              :userInfo="userInfo"
              @load-page="loadPage"
              @open-return-task-pool-dialog="
                openReturnTaskPoolDialog(scope.row)
              "
              @read-no-mistake="readNoMistake(scope.row)"
            ></action-btns-column>
          </template>
        </avue-crud>
      </el-drawer>

      <!-- 打回任务池--新 -->
      <return-task-pool-dialog
        :visible.sync="isShowSingleReturn"
        :isReturnPe="flowLevel == 3"
        :userInfo="userInfo"
        :row="currentRow"
        :qcTaskId="pageQuery.qcTaskId"
        @return-task-pool-done="returnSingleTaskPoolDone"
      ></return-task-pool-dialog>

      <!-- 一键已阅无误 1手动 2系统 -->
      <one-step-ok-dialog
        :visible.sync="isShowOneStepOkDialg"
        :orderId="orderId"
        :flowId="$route?.params?.id"
        :lastAuditerId="lastAuditerId"
        :name="nameGlobal"
        :searchQcTaskId="search?.qcTaskId"
        :queryQcTaskId="pageQuery?.qcTaskId"
        :taskType="taskType"
        :isQcOperate="permissions?.qc_operate"
        :userInfo="userInfo"
        :staParams="staParams"
        @one-step-ok-done="searchChange()"
      ></one-step-ok-dialog>

      <!-- 一键打回任务池 -->
      <one-step-return-dialog
        :visible.sync="isShowOneStepReturnDialog"
        :isQcOperate="permissions?.qc_operate"
        :name="nameGlobal"
        :lastAuditerId="lastAuditerId"
        :staffId="userInfo.staffId"
        :returnDic="returnDic"
        :qcTaskId="search.qcTaskId"
        :oneStepReturnObj="oneStepReturnObj"
      ></one-step-return-dialog>

      <!-- 术语加持列表 -->
      <term-list-dialog
        :visible.sync="termListDialogVisible"
        :orderId="orderId"
        :qcTaskId="pageQuery.qcTaskId"
        :staParams="staParams"
        @open-term-dialog="openTermDialog"
      ></term-list-dialog>

      <!-- 新增术语 -->
      <term-dialog
        :orderId="orderId"
        :qcTaskId="pageQuery.qcTaskId"
        :type="checkedType"
        :taskType="taskType"
        :visible.sync="termDialogVisible"
        :checkedLabel="checkedLabel"
        :staParams="staParams"
      ></term-dialog>

      <!-- 术语审核列表 -->
      <term-audit-dialog
        :orderId="orderId"
        :qcTaskId="pageQuery.qcTaskId"
        :visible.sync="termAuditDialogVisible"
        :staParams="staParams"
        :userInfo="userInfo"
        @trigger-dot="triggerTermAuditRedDot"
      ></term-audit-dialog>

      <!-- 质控留言 -->
      <qc-message-dialog
        :visible.sync="qcMessageDialogVisible"
        :orderId="orderId"
        :userInfo="userInfo"
        :name="currentRow?.name"
        :trId="currentRow?.lastAuditerId"
      ></qc-message-dialog>

      <!-- 选中文本弹出气泡 -->
      <div v-show="isShowLabel" class="popActBox" ref="popLabel">
        <div class="aiTitle d-f align-c">
          <img
            class="copilot"
            src="@/image/copilot-static.png"
            draggable="false"
          />
        </div>
        <ul>
          <li @click="copyText">复制</li>
          <li @click="openTermDialog(checkedType, checkedRow)">添加术语</li>
          <li @click="toTrans(checkedType, checkedRow)">翻译</li>
          <li v-if="!isSrcColumn" @click="toPolish(checkedType, checkedRow)">
            润色
          </li>
          <li v-if="!isSrcColumn" @click="openQuickQA">全局智能QA</li>
        </ul>
      </div>
    </div>

    <!-- 原文合并弹窗 -->
    <src-merge-dialog
      :qcTaskId="pageQuery?.qcTaskId"
      :slan="pageQuery?.slan"
      :tlan="pageQuery?.tlan"
      :visible.sync="srcMergeDialogVisible"
      :sentData="sentData"
      :staParams="staParams"
      @sent-merge="searchChange(page.current)"
    ></src-merge-dialog>

    <!-- 取消合并弹窗 -->
    <cancel-merge-dialog
      :qcTaskId="pageQuery?.qcTaskId"
      :visible.sync="cancelMergeDialogVisible"
      :row="currentRow"
      @sent-merge="searchChange(page.current)"
    ></cancel-merge-dialog>

    <!-- 查找替换弹窗 -->
    <find-replace-dialog
      v-if="flowTaskData.length"
      :pRefs="$refs"
      :qcTaskId="pageQuery?.qcTaskId"
      :staffId="userInfo.staffId"
      :updateListFn="loadPage"
      :visible.sync="findReplaceVisible"
    ></find-replace-dialog>

    <!-- copilot 组件 -->
    <copilot-panel
      ref="copilotPanel"
      :visible.sync="copilotVisible"
      :orderId="orderId"
      :qcTaskId="pageQuery?.qcTaskId"
      :staParams="staParams"
      :slan="pageQuery.slan"
      :tlan="pageQuery.tlan"
      @openFilterMode="handleOpenFilterMode"
    />
    <copilot-widget
      ref="copilotWidget"
      :errorFilterMode="errorFilterMode"
      :orderId="orderId"
      :qcTaskId="pageQuery?.qcTaskId"
      :staParams="staParams"
      @click="handleCopilotWidgetClick"
      @openFilterMode="handleOpenFilterMode"
      @closeFilterMode="handleCloseFilterMode"
    />
  </basic-container>
</template>

<script>
import { rebuildHighlight } from '@/util/richtext';
import SelectNameList from './components/SelectNameList';
import SelectRiskLevelList from './components/SelectRiskLevelList';
import SelectQcResultList from './components/SelectQcResultList';
import SelectQcTaskIdList from './components/SelectQcTaskIdList';
import DocPreview from './components/DocPreview';
import TermListDialog from './components/TermListDialog';
import TermDialog from './components/TermDialog';
import FindReplaceDialog from './components/FindReplaceDialog.vue';
import TermAuditDialog from './components/TermAuditDialog';
import QcMessageDialog from './components/QcMessageDialog';
import ReturnTaskPoolDialog from './components/ReturnTaskPoolDialog';
import OneStepOkDialog from './components/OneStepOkDialog';
import OneStepReturnDialog from './components/OneStepReturnDialog';
import SrcMergeDialog from './components/SrcMergeDialog';
import CancelMergeDialog from './components/CancelMergeDialog';
// 表格部分的组件
import ActionBtnsColumn from './components/MainTable/ActionBtnsColumn';
import QcStatusColumn from './components/MainTable/QcStatusColumn';
import TermListColumn from './components/MainTable/TermListColumn';
import TranslatedTextColumn from './components/MainTable/TranslatedTextColumn';
import { CopilotPanel, CopilotWidget } from './components/Copilot';

import {
  sentErrCheck,
  pageTask,
  peAuditDetail,
  qcUpdateText,
  queryTrIdByName,
  readNoMistake,
  returnQcTaskTj,
  sentAround,
  taskNumByNofinish,
  trPeAuditCountByOrderId,
  getQcUpdateReason,
  getCheckedList,
  batchUpdateLowCheckError,
  taskFinishDetail,
  getSpeedAndEditRemind,
} from '@/api/qc/qcflow';
import { statistics, getByType } from '@/api/dot/flow';
import { configList } from '@/api/dot/order';
import {
  cancelQcTask,
  checkQcControlTime,
  qcList,
  saveQcControlTime,
  submitSubQcTask,
  subTaskList,
  readNoMissBatch,
  reportAuditorSentCount,
  returnSubQcTask,
} from '@/api/dot/qc';
import clip from '@/util/clipboard';
import { hasValidChar } from '@/util/string';
import { getQueryObj } from '@/util/bom';
import {
  contextOption,
  flowTaskOption,
  trackBackOption,
  txtOption,
} from '@/const/crud/qc/qcflow';
import { groupingData } from '@/filters';
import { mapGetters, mapState } from 'vuex';
import RichText, { jsonTextToText } from '@/components/rich-text';
import EmEmbed from '@/components/rich-text/quill/emEmbed';
import { isDigitEmbed } from '@/components/rich-text/utils';
import { fieldsCheck } from '@/components/rich-text/utils/check';
import copilotMixin from './mixins/copilot';
import { COPILOT_FILTER_TRACKS } from './mixins/report';

import './index.scss';

const PARTIAL_LOAD_COUNT = 10;
export default {
  props: [
    'flowStatus',
    'orderId',
    'mainTaskStatus',
    'spark',
    'flowTlan',
    'staParams',
    'orderTag',
    'qcOrderType',
  ],
  mixins: [copilotMixin],
  components: {
    SelectNameList,
    SelectRiskLevelList,
    SelectQcResultList,
    SelectQcTaskIdList,
    DocPreview,
    TermListDialog,
    TermDialog,
    TermAuditDialog,
    QcMessageDialog,
    ReturnTaskPoolDialog,
    OneStepOkDialog,
    OneStepReturnDialog,
    ActionBtnsColumn,
    QcStatusColumn,
    TermListColumn,
    TranslatedTextColumn,
    RichText,
    SrcMergeDialog,
    CancelMergeDialog,
    FindReplaceDialog,
    CopilotPanel,
    CopilotWidget,
  },
  data() {
    return {
      tableLoading: false,
      pageQuery: {}, // 页面查询参数
      isShowSingleReturn: false, // 是否展示打回任务池弹窗
      isShowPreview: false, // 是否展示原文预览
      isShowOneStepOkDialg: false, // 是否触发展示一键已阅无误弹窗
      isShowOneStepReturnDialog: false, // 是否触发展示一键打回任务池弹窗
      srcMergeDialogVisible: false,
      cancelMergeDialogVisible: false,
      isShowLabel: false,
      checkedLabel: '',
      checkedType: '',
      checkedRow: null,
      remark: '',
      /* 一键打回任务池 start */
      oneStepReturnForm: {
        returnTag: [],
        remark: '',
      },
      /* 一键打回任务池 end */
      multipleSelection: [],
      rules: {
        returnTag: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个原因',
            trigger: 'change',
          },
        ],
        remark: [
          {
            required: true,
            message: '请输入批量打回任务的原因',
            trigger: 'blur',
          },
          {
            min: 5,
            max: 200,
            message: '长度在 5 到 200 个字符',
            trigger: 'blur',
          },
        ],
      },
      lowErrorInputText: '',
      searchName: '',
      qcListData: [],
      dialogQcListVisible: false,
      termListDialogVisible: false, // 术语加持列表弹窗
      termDialogVisible: false, // 术语弹窗显示控制
      termAuditDialogVisible: false, // 术语审核弹窗显示控制
      termAuditDotVisible: false, // 术语审核按钮小红点显示控制
      qcMessageDialogVisible: false, // 质控留言弹窗显示控制
      findReplaceVisible: false, // 质控留言弹窗显示控制
      hideFlag: false,
      isLoad: false,
      returnType: [],
      noFinish: { peAuditNum: 0, peNum: 0 },
      returnDic: [],
      oneStepData: {
        showOneStep: false,
        peAuditDetail: {
          passPercent: 0,
          sentenceNum: 0,
          packageNum: 0,
        },
      },
      page: {
        size: 20,
        current: 1,
        total: 0,
        pages: 0,
      },
      flowTaskData: [],
      flowTaskOption: flowTaskOption,
      contextData: [],
      contextOption: contextOption,
      trackBackOption: trackBackOption,
      trackBackData: [],
      contextDrawer: false,
      qcTaskIdFlag: false,
      qcTaskIdDic: [],
      search: {
        trId: '',
        levelList: '',
        qcResult: '',
        allFlag: false,
        packageNo: '',
        name: '',
        qcTaskId: '',
        srcText: '',
        tranText: '',
      },
      hasLoad: false,
      trsData: [],
      txtOption: txtOption,
      txtData: [],
      oneStepOkObj: {
        oneStepVisibleOk: false, //一键已阅无误的框
        oneStepOkType: '', //一键已阅无误类型 2：系统，1手动
        oneStepOkNum: 0, //译员风险等级0的句子数
        oneStepOkPass: false, //是否自动已阅无误
        oneStepOkText: '风险等级为0',
        oneStepOkPassList: [], //是否自动已阅无误
        oneStepOkPassNum: { oneNum: 0, twoNum: 0, threeNum: 0, zeroNum: 0 },
      },
      /* 一键打回任务池 start */
      oneStepReturnObj: {
        oneStepReturnType: '', //一键打回类型 2：系统，1手动
        tj: {
          submitSentNum: 0, //提交总句子数
          manualCorrectSentNum: 0, //手动确认无误句子数
          manualUpdateSentNum: 0, //手动修改句子数
          manualReturnSentNum: 0, //手动打回任务句子数
          autoCorrectSentNum: 0, //自动确认无误句子数
          pendNum: 0, //等待处理句子数
          packageNum: 0, //包数
          sentNum: 0, //句子数
        },
      },
      /* 一键打回任务池 end */
      currentRow: {}, // 当前点击的表格行数据
      dialogViewContext: false,
      dateViewContext: {},
      qcTaskIdShowTag: '',
      peStatus: null,
      qcTaskId: null,
      flowLevel: null,
      taskType: null,
      refreshFlag: false,
      focusIndex: null,
      errTagList: null,
      searchCtxDebug: {}, // 线上定位问题用
      lastAuditerId: null,
      nameGlobal: null,
      getNameListFlag: false,
      peKey: new Date().getTime(),
      selectedRows: [],
      sentData: [],
      isSrcColumn: false,
      showCaseBtn: false,
      showHalfAngleBtn: false,
      showFullAngleBtn: false,
      wordProgress: {
        finishWordCount: 0,
        wordCount: 0,
      },
      showDown: true,
      showReturnBtn: false,
      currentQcName: '',
    };
  },

  computed: {
    ...mapGetters(['permissions']),
    ...mapState({
      userInfo: (state) => state.user.userInfo,
    }),
  },

  watch: {
    spark: {
      handler(n, o) {
        subTaskList({ orderId: this.orderId }).then((res) => {
          this.qcListData = res.data.data;
        });
      },
    },
    'search.qcTaskId': {
      handler(n, o) {
        this.getQcsList();
      },
    },
  },

  created() {
    // 设置页面参数
    this.pageQuery = getQueryObj();
    this.taskType = this.pageQuery.taskType;
    this.qcTaskId = this.pageQuery.qcTaskId;
    this.orderId = this.pageQuery.orderId;
    this.getPeStatus();
    this.getErrTags();
    qcList({
      orderId: this.orderId,
      taskType: this.taskType,
      qcId: this.userInfo.staffId,
    }).then((res) => {
      let data = res.data.data;
      this.qcTaskIdFlag = data?.length > 1;
      this.qcTaskIdDic = data?.map((it) => {
        return {
          label:
            (it.taskType == 1 ? '主' : '子') +
            it.id.substr(it.id.length - 6, it.id.length) +
            ' ' +
            it.qcId +
            (it.newPerson == 2 ? '(新人)' : ''),
          value: it.id,
        };
      });
    });
  },

  mounted() {
    document.addEventListener('click', this.bodyCloseMenus);
    this.recordOperation(1);
    this.getWordsProgress();
    if (this.taskType == 2) {
      this.speedNotice(1);
    }
    document
      .querySelector('.backTop')
      .addEventListener('scroll', this.windowScrollListener);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.bodyCloseMenus);
    document
      .querySelector('.backTop')
      .removeEventListener('scroll', this.windowScrollListener);
  },

  methods: {
    getQcsList() {
      qcList({
        orderId: this.orderId,
        taskType: this.taskType,
        qcId: this.userInfo.staffId,
      }).then((res) => {
        let data = res.data.data;
        const currentQc = res.data?.data?.filter((item) => {
          return item.id === this.search.qcTaskId;
        });
        if (
          currentQc?.length &&
          this.qcOrderType === 2 &&
          currentQc[0].status === 3
        ) {
          this.showReturnBtn = true;
          this.currentQcName = currentQc[0].qcId;
        } else {
          this.showReturnBtn = false;
        }
      });
    },
    backToQc() {
      this.$confirm(
        `确认打回子控【${this.currentQcName}】的任务吗？打回后，该任务会返回该质控的质控列表——进行中的任务中。`,
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          showCancelButton: true,
          type: 'warning',
        },
      )
        .then(() => {
          returnSubQcTask({
            id: this.search.qcTaskId,
            qcId: this.userInfo.staffId,
          }).then((res) => {
            this.$message.success('操作成功');
            this.getQcsList();
            this.searchChange(this.page.current);
          });
        })
        .catch(() => {});
    },

    backDown() {
      const scrollHeight = document.querySelector('.backTop').scrollHeight;
      document
        .querySelector('.backTop')
        .scrollTo({ top: scrollHeight, behavior: 'smooth' });
    },

    windowScrollListener() {
      const element = document.querySelector('.backTop');
      if (element.scrollTop === element.scrollHeight - element.clientHeight) {
        this.showDown = false;
      } else {
        this.showDown = true;
      }
    },

    rebuildHighlight,
    handleClickOutside() {
      this.focusIndex = null;
    },
    getWordsProgress() {
      const qcTaskId =
        this.pageQuery.taskType == 2
          ? this.pageQuery.qcTaskId
          : this.getQcTaskId();
      taskFinishDetail({
        orderId: this.orderId,
        taskId: qcTaskId,
      }).then((res) => {
        this.wordProgress = res.data.data;
      });
    },
    speedNotice() {
      getSpeedAndEditRemind({
        qcTaskId: this.pageQuery.qcTaskId,
        remindType: 1, //type--1.过程预警 2.提交预警
      }).then((res) => {
        if (res.data.data) {
          const msg =
            res.data.data === 1
              ? '检测当前提交速度过快，请详细审核后提交哦～'
              : '检测当前修改率过低，请详细审核后提交哦～';
          this.$alert(msg, '提示', {
            confirmButtonText: '确定',
          });
        }
      });
    },

    updateLowError(type) {
      this.$confirm('替换后无法还原，请确认后操作！', '提示', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          batchUpdateLowCheckError({
            orderId: this.orderId,
            qcTaskId: this.pageQuery.qcTaskId,
            lowErrorType: type,
          }).then(() => {
            this.$message.success('处理中，请稍后进入查看');
            this.handleCloseFilterMode();
          });
        })
        .catch(() => {});
    },

    // 异常原文合并
    mergeText() {
      this.sentData = [];
      if (this.selectedRows.length < 2) {
        this.$message.warning('请选择至少2个非审核中状态且有权限的句子');
        return;
      }
      const qcStatus = this.selectedRows.map((it) => it.qcStatus);
      const statusFlag = qcStatus.some((it) => {
        return it == -1;
      });
      if (statusFlag) {
        this.$message.warning('请选择至少2个非审核中状态且有权限的句子');
        return;
      }
      const fileIds = this.selectedRows.map((it) => it.fileId);
      const flag = fileIds.some((it) => {
        return it != fileIds[0];
      });
      if (flag) {
        this.$message.warning('所选句子必须在同一个稿件中，不支持跨原稿合并');
        return;
      }
      const actPermission = this.selectedRows.map((it) => {
        return (
          it.showQcTextUpdate ||
          it.showQcTextUpdateOk ||
          it.showQcTextUpdateMtOut
        );
      });
      const permissionFlag = actPermission.some((it) => {
        return it == false;
      });
      if (permissionFlag) {
        this.$message.warning('请选择个人质控任务下有操作权限的句子');
        return;
      }
      const mergeFlag = this.selectedRows.some((it) => {
        return it.showCancelMerge;
      });
      if (mergeFlag) {
        this.$message.warning('所选句子必须是未合并的句子');
        return;
      }
      const embedFlag = this.isContainEmbed();
      if (embedFlag) {
        this.$message.warning(
          '选择的句子含图标等占位符，系统不支持进行合并操作',
        );
        return;
      }
      this.sentData = this.selectedRows.sort(this.orderByNo);
      this.srcMergeDialogVisible = true;
    },

    // 按照sentNo排序
    orderByNo(a, b) {
      if (a.sentenceNo < b.sentenceNo) {
        return -1;
      } else if (a.sentenceNo > b.sentenceNo) {
        return 1;
      } else if (a.sentenceNo == b.sentenceNo) {
        return 0;
      }
    },

    // 判断句子中是否包含域
    isContainEmbed() {
      const srcText = this.selectedRows.map((item) => {
        return JSON.parse(item.srcText);
      });
      const src = [].concat.apply([], srcText);
      const srcEmbedFlag = src.some((item) => {
        return isDigitEmbed(item);
      });
      const mtText = this.selectedRows.map((item) => {
        return JSON.parse(item.mtText);
      });
      const mt = [].concat.apply([], mtText);
      const mtEmbedFlag = mt.some((item) => {
        return isDigitEmbed(item);
      });
      const peTextShow = this.selectedRows.map((item) => {
        return JSON.parse(item.peTextShow);
      });
      const pe = [].concat.apply([], peTextShow);
      const peEmbedFlag = pe.some((item) => {
        return isDigitEmbed(item);
      });
      const embedFlag = srcEmbedFlag || mtEmbedFlag || peEmbedFlag;
      return embedFlag;
    },

    // 打开取消合并弹窗
    openCancelMergeDialog(row) {
      this.currentRow = row;
      this.cancelMergeDialogVisible = true;
    },

    rowStyle({ row }) {
      if (row.sentenceNo === this.currentRow.sentenceNo) {
        return 'bg-lightBlue';
      }
    },
    bodyCloseMenus(e) {
      if (!this.$refs.popLabel.contains(e.target)) {
        if (!window.getSelection().toString()) {
          this.isShowLabel = false;
        }
      }
    },

    // 获取机翻直出错误类型
    getErrTags() {
      getQcUpdateReason({}).then((res) => {
        this.errTagList = res?.data?.data;
      });
    },

    // 获取pe状态
    getPeStatus() {
      getByType({
        orderId: this.orderId,
        type: 4,
      }).then((res) => {
        const data = res?.data?.data;
        if (data) {
          this.$emit('flowLevel', data.flowLevel);
          this.flowLevel = data.flowLevel;
          this.peStatus = data.status;
        }
      });
    },

    //点击原文预览
    toPreview(row, type) {
      // if (type == 1) {
      //   return;
      // }
      if (!row.url) {
        this.$message.warning('暂不支持此句子格式的原稿预览和定位');
        return;
      }
      this.isShowPreview = true;
      this.peKey = +new Date().getTime();
      this.currentRow = row;
      statistics(
        Object.assign(
          {
            event_name: '原文预览',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    // 鼠标选中文字事件
    handleRightClick(type, row, e) {
      this.checkedLabel = '';
      if (!window.getSelection().toString()) {
        this.isShowLabel = false;
      }
      this.checkedType = type;
      this.checkedRow = row;
      this.checkedLabel = window.getSelection().toString();
      this.setBoxPosition(e.pageX, e.pageY);
    },

    // 计算弹窗位置
    setBoxPosition(X, Y) {
      let popLabel = this.$refs.popLabel;
      const maxHeight = document.body.clientHeight;
      let height = Y + 10;
      if (maxHeight < height + 40) {
        height = height - 60;
      }
      popLabel.style.cssText = `left:${X + 10}px;top:${height}px;`;
      //弹出标签列表
      this.isShowLabel = true;
    },

    // 选中文字后复制
    copyText(event) {
      this.isShowLabel = false;
      clip(this.checkedLabel, event);
      statistics(
        Object.assign(
          {
            event_name: '选中复制',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    // 批量已阅无误
    batchNoMisstake() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否批量已阅无误选中的句子？', '提示', {
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            let sentenceIds = this.multipleSelection.map((it) => it.id);
            readNoMissBatch({
              sentenceIds: sentenceIds,
              operateQcTaskId: this.pageQuery.qcTaskId,
              flowId: this.$route.params.id,
              operateQcId: this.userInfo.staffId,
            }).then((res) => {
              this.searchChange();
              this.getWordsProgress();
              if (this.pageQuery.taskType === '2') {
                this.speedNotice();
              }
            });
          })
          .catch(() => {});
        statistics(
          Object.assign(
            {
              event_name: '批量已阅无误',
              event_type: 'click',
              class_name: 'readNoMissBatch',
              class_url: '/dotadmin/dotadmin/qc/readNoMissBatch',
              event_params:
                '{sentenceIds: sentenceIds, operateQcTaskId:this.pageQuery.qcTaskId,flowId:this.$route.params.id,operateQcId: this.userInfo.staffId}',
            },
            this.staParams,
          ),
        );
      } else {
        this.$message.error('请选择至少一个可以已阅无误的句子或有权限的句子');
      }
    },

    handleSelectionChange(val) {
      this.selectedRows = val;
      this.multipleSelection = val.filter((item) =>
        this.canReadNoMistake(item),
      );
    },

    canReadNoMistake(row) {
      return (
        row.repeatId == null &&
        row.qcStatus === 1 &&
        row.peText != null &&
        row.peText !== '' &&
        this.chooeseItemShowFlag(row)
      );
    },

    showQcTaskIdTag(row) {
      if (parseInt(this.pageQuery.taskType) === 2) {
        if (row.qcTaskId !== this.pageQuery.qcTaskId) {
          return true;
        }
      } else {
        if (
          row.qcTaskId !== (this.qcTaskIdShowTag || this.pageQuery.qcTaskId)
        ) {
          return true;
        }
        if (
          this.qcTaskIdShowTag &&
          this.qcTaskIdShowTag !== this.pageQuery.qcTaskId
        ) {
          return true;
        }
      }
      return false;
    },

    getQcTaskId() {
      if (this.search.qcTaskId) {
        return this.search.qcTaskId;
      }
      if (this.search.name && !this.search.qcTaskId) {
        return this.pageQuery.qcTaskId;
      }
      return null;
    },

    getQcTaskIdForTaskNumByNofinish() {
      if (parseInt(this.pageQuery.taskType) === 1) {
        if (this.search.qcTaskId) {
          return this.search.qcTaskId;
        }
        return null;
      } else {
        return this.pageQuery.qcTaskId;
      }
    },

    submitSubQcTask(item) {
      submitSubQcTask({
        qcTaskId: item.qcTaskId,
        qcId: this.userInfo.staffId,
        submitType: 1,
      }).then((res) => {
        this.$message.success('提交子质控任务成功！');
        subTaskList({ orderId: this.orderId }).then((res) => {
          this.qcListData = res.data.data;
        });
      });
    },

    cancelQcTask(item) {
      cancelQcTask({
        qcTaskId: item.qcTaskId,
        qcId: this.userInfo.staffId,
      }).then((res) => {
        let code = res.data.data;
        if (code === -2) {
          this.$message.error('该质控任务状态已修改');
        } else if (code === -3) {
          this.$message.error('没有权限提交');
        } else if (code > 0) {
          this.$message.success('取消子质控任务成功！');
          subTaskList({ orderId: this.orderId }).then((res) => {
            this.qcListData = res.data.data;
          });
        } else if (code === -99) {
          this.$message.error('系统异常');
        }
      });
    },

    // 主质控可以整体提交任务的条件是
    overallDubmission() {
      this.$emit('changeMainTaskStatus', 0);
      this.dialogQcListVisible = false;
    },

    // 判断一键打回、一键已阅无误
    showItemFlag() {
      let bol = this.qcTaskIdDic.findIndex(it.status === 3 || it.status === -1);
      return bol > -1 || this.pageQuery.qcTaskId == this.search.qcTaskId;
    },

    // 判断操作、已阅无误、打回任务池是否展示
    chooeseItemShowFlag(row) {
      let passQcTaskId = this.pageQuery.qcTaskId;
      if (passQcTaskId == row.qcTaskId || passQcTaskId == row.qcTaskIdAssist) {
        return true;
      }
      return false;
    },

    // 记录操作
    recordOperation(operateType) {
      checkQcControlTime({
        qcTaskId: this.pageQuery.qcTaskId,
        operateType: operateType,
      }).then((res) => {
        let code = res.data.data;
        if (code < 0) {
          saveQcControlTime({
            qcTaskId: this.pageQuery.qcTaskId,
            operateType: operateType,
          }).then((res2) => {
            let code2 = res2.data.data;
            if (code2 > 0) {
            }
          });
        }
      });
    },

    // 质控留言提交
    hideChange(val) {
      this.loadPage();
    },

    // 打开术语加持列表弹窗
    openTermListDialog() {
      this.termListDialogVisible = true;
    },

    // 打开术语弹窗
    openTermDialog(type) {
      // 选中译文气泡的场景
      if (type) {
        this.isShowLabel = false;
      }
      this.termDialogVisible = true;
    },

    // 打开术语审核弹窗
    openTermAuditDialog() {
      this.termAuditDialogVisible = true;
    },

    // 展示“术语审核”上的小红点
    triggerTermAuditRedDot(val) {
      this.termAuditDotVisible = val;
    },

    getGrey({ row, index }) {
      if (row.repeatId != null || row.wordCount === 0) {
        return 'greyRow';
      }
      return '';
    },

    // 低错格式转换
    rebuildErrors(list) {
      return (
        list?.map((item) => ({
          errorType: item.errorType,
          position: [item.errorSPos, item.errorEPos],
          payload:
            item.errorType === 'spell_error' ? item.suggests : item.errMsgs,
        })) ?? []
      );
    },

    // 获取焦点
    focusText($event, jsonText, row, index) {
      this.focusIndex = index;
      this.lowErrorInputText = JSON.stringify(jsonText);
    },

    // 点击某个单元格
    clickCell(row, column, cell, event) {
      if (
        column.label != '译文' &&
        event.target.className != EmEmbed.className
      ) {
        this.focusIndex = null;
      }
      if (column?.label == '译文' || column?.label == '机翻译文') {
        this.isSrcColumn = false;
      } else {
        this.isSrcColumn = true;
      }
    },

    // 失去焦点
    blurText(text, jsonText, textAll, row, index, type) {
      let lowErrorInputText = this.lowErrorInputText;
      row.peTextOldShow = lowErrorInputText;
      row.peTextShowOld = JSON.stringify(jsonText); // 术语检查时使用
      // 低错检查
      let params = {
        texts: [
          {
            sentId: row.id,
            src: row.srcText,
            tgt: row.peTextOldShow,
          },
        ],
        srcLan: this.pageQuery.slan,
        tgtLan: this.pageQuery.tlan,
        orderId: row.orderId,
        saveError: false,
      };
      sentErrCheck(params).then((res) => {
        if (res.data?.data) {
          row.errorData = this.rebuildErrors(res.data?.data[0].low_error_list);
        } else {
          row.errorData = [];
        }
      });
    },

    imitateInput(text, jsonText, row, index, type) {
      // if (jsonText.length == 1) {
      //   jsonText[0].insert = jsonText[0].insert.trim();
      // }
      // if (jsonText.length > 1) {
      //   let endIndex = jsonText.length - 1;
      //   jsonText[0].insert = jsonText[0].insert.trimStart();
      //   jsonText[endIndex].insert = jsonText[endIndex].insert.trimEnd();
      // }
      this.isShowLabel = false;
      this.$set(row, 'editedPeText', JSON.stringify(jsonText));
      this.lowErrorInputText = JSON.stringify(jsonText);
      row.peTextOldShow = this.lowErrorInputText;
      this.$set(row, 'isDisabled', JSON.stringify(jsonText) === row.peTextShow);
    },

    // 一键还原机翻译文
    resetPeText(row, index) {
      let currentPeTextShow = row.peTextShow;
      this.lowErrorInputText = row.mtText;
      if (
        row.peTextShow.length == 0 ||
        row.peTextShow.length == row.mtText.length
      ) {
        let newPetext = JSON.parse(row.mtText);
        newPetext.push({ insert: '\n' });
        row.peTextShow = JSON.stringify(newPetext);
      } else {
        row.peTextShow = row.mtText;
      }
      setTimeout(() => {
        row.peTextShow = row.mtText;
      }, 200);
      row.editedPeText = row.mtText;
      // 低错检查
      let params = {
        texts: [
          {
            sentId: row.id,
            src: row.srcText,
            tgt: row.mtText,
          },
        ],
        srcLan: this.pageQuery.slan,
        tgtLan: this.pageQuery.tlan,
        orderId: row.orderId,
        saveError: false,
      };
      sentErrCheck(params).then((res) => {
        if (res.data?.data) {
          row.errorData = this.rebuildErrors(res.data?.data[0].low_error_list);
        } else {
          row.errorData = [];
        }
      });
      this.$set(row, 'isDisabled', currentPeTextShow === row.peTextShow);
    },

    init() {
      configList().then((res) => {
        this.returnDic = groupingData(res.data.data, 'remark', 'list');
      });
      this.loadPage();
    },

    // 打开留言弹窗
    openQcMessageDialog(row) {
      this.currentRow = row;
      this.qcMessageDialogVisible = true;
    },

    viewContext(row) {
      this.focusIndex = null;
      this.isShowPreview = false;
      this.currentRow = row;
      sentAround({
        fileId: row.fileId,
        sentenceNo: row.sentenceNo,
        taskType: this.taskType,
      }).then((res) => {
        this.contextDrawer = true;
        this.contextData = res.data.data.map((item) => {
          return Object.assign(
            { editFlag: false, errorData: this.rebuildErrors(item.errDtoList) },
            item,
          );
        });
      });
      statistics(
        Object.assign(
          {
            event_name: '查看上下文',
            event_type: 'click',
            class_name: 'sentAround',
            class_url: '/dotadmin/dotadmin/qcflow/sentAround',
            event_params: '{fileId: row.fileId, sentenceNo: row.sentenceNo}',
          },
          this.staParams,
        ),
      );
    },

    handleSizeChange(val) {
      this.page.size = val;
      this.loadPage();
    },

    handleCurrentChange(val) {
      this.page.current = val;

      this.amendPage();
      this.loadPage();
    },

    // 处理筛选情况下的一个边界bug：改变句子状态后的数量少于2页，但页码还能选到2的情况：重置页码为1
    amendPage() {
      // 没有状态的筛选，不处理
      if (this.search.qcResult === '') return;

      const statusChangedCount = this.flowTaskData?.filter(
        (item) => item.qcStatus != this.search.qcResult,
      ).length;

      // 实际总数少于 pagesize，表示只够1页了
      if (this.page.total - statusChangedCount < this.page.size) {
        this.page.current = 1;
      }
    },

    resetChange() {
      this.search.levelList = '';
      this.search.name = '';
      this.search.qcResult = '';
      this.search.srcText = '';
      this.search.qcTaskId = '';
      this.search.tranText = '';
      this.getNameListFlag = true;
    },

    searchChange(flag) {
      this.isShowPreview = false;
      this.focusIndex = null;
      if (
        this.search.name &&
        !this.search.qcTaskId &&
        parseInt(this.pageQuery.taskType) === 1 &&
        this.qcTaskIdFlag
      ) {
        return this.$message.warning('请选择要操作的质控任务ID');
      }
      this.getWordsProgress();
      this.isLoad = false;
      this.page.current = flag ? flag : 1;
      this.searchName = this.search.name;
      this.loadPage();
      statistics(
        Object.assign(
          {
            event_name: '带搜索条件更新列表',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    fetchListFn() {
      const qcTaskId =
        this.pageQuery.taskType == 2
          ? this.pageQuery.qcTaskId
          : this.getQcTaskId();

      const { isOpen: isFilterModeOpen, errorItem } = this.errorFilterMode;
      console.log(errorItem.parent ? errorItem.type : '');
      const errItemType = errorItem.parent ? errorItem.type : '';
      if (
        isFilterModeOpen &&
        errItemType === 'case_error' &&
        this.pageQuery?.tlan === 'en'
      ) {
        this.showCaseBtn = true;
      } else {
        this.showCaseBtn = false;
      }
      if (
        isFilterModeOpen &&
        errItemType === 'punctuation_error' &&
        this.pageQuery?.tlan === 'en'
      ) {
        this.showHalfAngleBtn = true;
      } else {
        this.showHalfAngleBtn = false;
      }
      if (
        isFilterModeOpen &&
        errItemType === 'punctuation_error' &&
        this.pageQuery?.tlan === 'zh-CN'
      ) {
        this.showFullAngleBtn = true;
      } else {
        this.showFullAngleBtn = false;
      }
      // 获取智能QA筛选过的数据
      if (isFilterModeOpen) {
        return getCheckedList({
          current: this.page.current,
          size: this.page.size,
          orderId: this.orderId,
          taskType: this.taskType,
          qcTaskId: this.pageQuery.qcTaskId,
          errorType: errorItem.parent ? errorItem.parent.type : errorItem.type,
          lowErrorType: errorItem.parent ? errorItem.type : '',
        });
      }
      return pageTask(
        Object.assign(
          {
            current: this.page.current,
            size: this.page.size,
          },
          {
            taskType: this.taskType,
            orderId: this.orderId,
            name: this.search.name,
            levelList: this.search.levelList,
            qcResult: this.search.qcResult,
            hideFlag: this.hideFlag,
            qcTaskId,
            srcText: this.search.srcText,
            tranText: this.search.tranText,
          },
        ),
      );
    },
    // 防止句子引用被缓存导致顺序错乱，加载句子钱提前清空下富文本行引用
    resetRTRowRefs() {
      for (const key in this.$refs) {
        if (this.$refs.hasOwnProperty.call(this.$refs, key)) {
          if (key.indexOf('richtext-column') > -1 && this.$refs[key]) {
            delete this.$refs[key];
          }
        }
      }
    },
    loadPage() {
      this.tableLoading = true;
      this.backTop();
      this.resetRTRowRefs();

      this.fetchListFn()
        .then((response) => {
          let tmpe = [];
          this.flowTaskData = [];
          this.lowErrorInputText = '';
          response.data.data.records.forEach((ele) => {
            tmpe.push(ele);
          });
          this.qcTaskIdShowTag = this.search.qcTaskId;
          this.lastAuditerId = '';
          this.nameGlobal = '';
          this.oneStepData.showOneStep = false;
          //搜索条件带了昵称
          if (this.search.name) {
            //根据昵称查询
            queryTrIdByName({ name: this.search.name }).then((res) => {
              this.searchCtxDebug = {
                queryTrIdByNameData: {
                  res: res.data,
                },
                search: this.search,
              };
              this.lastAuditerId = res.data?.data;
              this.nameGlobal = this.search.name;
              //如果有译员ID
              if (this.lastAuditerId && this.getQcTaskId()) {
                trPeAuditCountByOrderId({
                  orderId: this.orderId,
                  trId: res.data.data,
                }).then((rs) => {
                  if (rs.data.data) {
                    this.oneStepData.showOneStep =
                      this.lastAuditerId &&
                      (response.data.data.records.length > 0 ||
                        rs.data.data > 0);
                  } else {
                    this.oneStepData.showOneStep =
                      this.lastAuditerId &&
                      response.data.data.records.length > 0;
                  }
                });

                //查询一次通过率数据
                peAuditDetail({
                  orderId: this.orderId,
                  lastAuditerId: this.lastAuditerId,
                  qcTaskId: this.getQcTaskId(),
                }).then((res) => {
                  this.oneStepData.peAuditDetail = res.data.data;
                });
              }
            });
          }
          Promise.all(response.data.data.records)
            .then(() => {
              this.page = response.data.data;
              // 分步加载表格数据 --> 每次固定的少量条数
              this.flowTaskData = [];
              this.partialLoad(tmpe);

              taskNumByNofinish({
                orderId: this.orderId,
                qcTaskId: this.getQcTaskIdForTaskNumByNofinish(),
              }).then((res) => {
                this.noFinish = res.data.data;
              });
            })
            .then(() => {
              this.$parent.$parent.$parent.$parent.$parent.$refs.scrollview.scrollTop =
                this.$parent.$parent.$parent.$parent.$parent.scroll;
            });
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },

    partialLoad(list) {
      if (list.length <= 0) return;

      this.backTop();
      const curPart = list.splice(0, PARTIAL_LOAD_COUNT).map((item) => {
        return Object.assign(
          {
            editFlag: false,
            errorData: this.rebuildErrors(item.errDtoList),
          },
          item,
        );
      });
      this.flowTaskData = this.flowTaskData.concat(curPart);
      // 需要用宏任务来确保在loading的DOM消失后加载剩余内容
      setTimeout(() => {
        this.partialLoad(list);
      }, 0);
    },

    backTop() {
      document.querySelector('.backTop').scrollTop = 0;
    },

    handleClose() {
      this.contextDrawer = false;
    },

    // 触发一键已阅无误弹窗逻辑
    openOneStepOkDialog() {
      this.isShowOneStepOkDialg = true;
    },

    // 单个打回任务池弹窗
    openReturnTaskPoolDialog(row) {
      this.currentRow = row;
      this.isShowSingleReturn = true;
    },

    // 单个打回任务池完成后，不刷新列表数据，直接修改当前的row的数据
    returnSingleTaskPoolDone() {
      this.currentRow.showReturnQcTask = false;
      this.currentRow.showReportSent = false;
      this.currentRow.showReadNoMistake = false;
      this.currentRow.showTtoolbar = false;
      this.currentRow.qcStatus = -1;
      this.currentRow.peText = null;
      this.currentRow.peTextShow = null;
      this.currentRow.name = null;
      this.currentRow.lastAuditerId = null;
      this.currentRow.editFlag = true;
    },

    // 一键打回任务池
    showOneStepReturnManual() {
      reportAuditorSentCount({
        auditorId: this.lastAuditerId,
        qcTaskId: this.search.qcTaskId || this.pageQuery.qcTaskId,
        isHost: parseInt(this.pageQuery.taskType) === 1,
      }).then((res) => {
        if (res.data.data > 2) {
          returnQcTaskTj({
            trId: this.lastAuditerId, //this.currentRow.lastAuditerId,
            orderId: this.orderId,
            qcTaskId: this.getQcTaskId(),
          }).then((res) => {
            this.isShowOneStepReturnDialog = true;
            this.oneStepReturnObj.oneStepReturnType = 1;
            this.oneStepReturnObj.tj = res.data.data;
          });
        } else {
          this.$message.info(
            '至少举报标记三个有问题的句子才能使用一键打回任务池功能',
          );
        }
      });
      statistics(
        Object.assign(
          {
            event_name: '一键打回任务池',
            event_type: 'click',
            class_name: 'returnQcTaskTj',
            class_url: '/dotadmin/dotadmin/qcflow/returnQcTaskTj',
            event_params:
              '{trId: this.currentRow.lastAuditerId, orderId: this.orderId, qcTaskId:this.getQcTaskId()}',
          },
          this.staParams,
        ),
      );
    },

    readNoMistakeFn(row) {
      //已阅无误
      readNoMistake({
        sentId: row.id,
        orderId: this.orderId,
        trId: row.lastAuditerId,
        flowId: this.$route.params.id,
        qcTaskId: row.qcTaskId,
        operateQcTaskId: this.pageQuery.qcTaskId,
        operateQcId: this.userInfo.staffId,
      }).then((res) => {
        this.isLoad = false;
        row.peTextShow = row.peTextShowTemp;
        row.qcStatus = 3;
        row.editFlag = true;
        row.name = row.name;
        this.getWordsProgress();
        if (this.pageQuery.taskType === '2') {
          this.speedNotice();
        }
        // this.searchChange(this.page.current);
      });
      statistics(
        Object.assign(
          {
            event_name: '已阅无误',
            event_type: 'click',
            event_type: 'readNoMistake',
            class_url: '/dotadmin/dotadmin/qcflow/readNoMistake',
            event_params:
              '{sentId: row.id, orderId: this.orderId, trId: row.lastAuditerId, flowId: this.$route.params.id, qcTaskId: row.qcTaskId, operateQcTaskId: this.pageQuery.qcTaskId}',
          },
          this.staParams,
        ),
      );
    },

    // 已阅无误
    readNoMistake(row) {
      this.recordOperation(2);
      this.isLoad = true;
      this.currentRow = row;
      this.readNoMistakeFn(row);
      this.isLoad = false;
    },

    qcUpdateFn(index, row, level, type) {
      console.log(jsonTextToText(row.editedPeText));
      if (!hasValidChar(jsonTextToText(row.editedPeText))) {
        this.$confirm(
          '<h4>确定要将此句译文保存为空吗?</h4><div>请谨慎操作！译文为空的场景一般应用于原文断句异常时，已将此句的译文合并入其他句子中。</div>',
          '译文为空预警',
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          },
        )
          .then(() => {
            this.confirmUpdateText(row, level);
          })
          .catch(() => {
            row.editedPeText = row.peTextShow;
            row.peTextShowOld = row.peTextShow;
            let newPetext = JSON.parse(row.peTextShow);
            newPetext.push({ insert: '' });
            row.peTextShow = JSON.stringify(newPetext);
          });
      } else {
        this.confirmUpdateText(row, level);
      }
    },

    // 保存
    confirmUpdateText(row, level) {
      qcUpdateText({
        sentId: row.id,
        level: level,
        peText: row.editedPeText,
        trId: this.currentRow.lastAuditerId,
        orderId: this.orderId,
        qcTaskId: row.qcTaskId,
        operateQcTaskId: this.pageQuery.qcTaskId,
        operateQcId: this.userInfo.staffId,
      }).then((res) => {
        let params = {
          texts: [
            {
              sentId: row.id,
              src: row.srcText,
              tgt: row.editedPeText,
            },
          ],
          srcLan: this.pageQuery.slan,
          tgtLan: this.pageQuery.tlan,
          orderId: row.orderId,
          saveError: true,
        };
        sentErrCheck(params).then();
        this.isLoad = false;
        row.peTextShow = row.editedPeText;
        row.peTextShowTemp = row.peTextShow;
        row.isDisabled = true;
        row.qcStatus = 2;
        row.editFlag = true;
        row.showReadNoMistake = false;
        this.$message.success('保存成功');
        this.$refs.copilotWidget.updatePrompt({
          orderId: this.orderId,
          qcTaskId: this.pageQuery.qcTaskId,
        });
        this.getWordsProgress();
        if (this.pageQuery.taskType === '2') {
          this.speedNotice();
        }
      });

      const { isOpen: isFilterModeOpen, errorItem } = this.errorFilterMode;
      isFilterModeOpen &&
        statistics(
          Object.assign({}, this.staParams, COPILOT_FILTER_TRACKS.submitSent, {
            event_params: {
              copilotType: errorItem.type,
              sentId: row.id,
              level,
            },
          }),
        );
    },

    // 域匹配检查
    sentDigitCheck(row) {
      const peJsonText = JSON.parse(row.editedPeText ?? row.peText);
      const isMatched = fieldsCheck(peJsonText);
      if (!isMatched) {
        const msgTemplate =
          '<p>保存失败！红色译文框的内容中检测存在如下问题：</P>' +
          '<p style="color: #ED7266;">序号图标没有成对出现、域开闭顺序不对、域交叉等问题</p>' +
          '<p>请按照图示<em class="field-icon open">1</em><em class="field-icon close">1</em> 修改后重新提交</p>';

        this.$confirm(msgTemplate, '保存失败', {
          customClass: 'qc-field-check-warning',
          dangerouslyUseHTMLString: true,
          confirmButtonText: '知道了',
          showCancelButton: false,
        });
      }
      this.$set(row, 'hasDigitError', !isMatched);

      return isMatched;
    },
    submitQcUpdateText(typeAct, index, row, level) {
      const isDigitMatched = this.sentDigitCheck(row);
      if (!isDigitMatched) return;

      if (row.isDisabled || row.isDisabled == null) {
        return;
      }
      row.qcResult = level;
      row.peTextShowOld = row.peTextOldShow;
      this.recordOperation(2);
      this.currentRow = row;
      let params = {
        texts: [
          {
            sentId: row.id,
            src: row.srcText,
            tgt: row.peTextOldShow,
          },
        ],
        srcLan: this.pageQuery.slan,
        tgtLan: this.pageQuery.tlan,
        orderId: row.orderId,
        saveError: false,
      };
      sentErrCheck(params).then((res) => {
        if (res.data?.data) {
          row.errorData = this.rebuildErrors(res.data?.data[0].low_error_list);
        } else {
          row.errorData = [];
        }
        this.qcUpdateFn(index, row, level, typeAct);
        this.isLoad = false;
      });
      statistics(
        Object.assign(
          {
            event_name: '错误检查',
            event_type: 'click',
          },
          this.staParams,
        ),
      );
    },

    reflash() {
      this.$router.replace({
        path: '/refresh',
      });
    },

    btnReturnSuccess(msg, fn) {
      this.$message.success({
        message: msg || '提交成功',
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          } else {
            this.$router.replace({
              path: '/refresh',
            });
          }
        },
      });
    },
    btnReturnFail(msg, fn) {
      this.$message.error({
        message: msg || '提交失败',
        duration: 1500,
        onClose: () => {
          if (fn) {
            fn();
          } else {
            this.$router.replace({
              path: '/refresh',
            });
          }
        },
      });
    },
  },
};
</script>
<style lang="scss" src="./index.scss"></style>
